export const EMPTY_GROUP_NAME = '028b4b00-f133-4a70-a19e-4df3d5df906f'; // v4() 随机生成的字符串
